// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__9wU3h"};